import React, { useRef, useEffect } from 'react';
import {
  Paper, Typography, Table, TableBody, TableCell, TableRow, Box,
  TextField, Button, IconButton, List, ListItem, ListItemText
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import { useSelector } from 'react-redux';

const BoardWritePopup = ({
  board,
  boardTitle,
  setBoardTitle,
  setBoardInptId,
  setBoardInqCnt,
  boardCntn,
  setBoardCntn,
  setFiles,
  setUploadedFiles,
  setDeleteFiles,
  files = [],
  uploadedFiles = [],
  boardQuery,
  setHrankNotiNo,
  setPNotiNo,
  setAnswLevl,
  setAnswOrder,
  boardType
}) => {
  const userId = useSelector((state) => state.user.userId);
  const fileInputRef = useRef();
  // 파일 추가 (누적 방식)
  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    fileInputRef.current.value = ''; // 파일 input 초기화
  };

  // 특정 파일 삭제
  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  // 기존 파일 삭제
  const handleRemoveUploadedFile = (saveFileNm) => {
    setUploadedFiles(prev => prev.filter(f => (f.SAVE_FILE_NM || f.saveFileNm) !== saveFileNm));
    // 삭제할 파일 정보(객체 전체)를 deleteFiles에 추가
    setDeleteFiles(prev => [
      ...prev,
      ...uploadedFiles.filter(f => (f.SAVE_FILE_NM || f.saveFileNm) === saveFileNm)
    ]);
  };

  const tableSx = {
    border: '1px solid #dcdcdc',
    '& .MuiTableCell-root': {
      border: '1px solid #dcdcdc',
      fontSize: 13,
      padding: '6px 10px',
    },
  };

  const thCell = {
    backgroundColor: '#f5f7fa',
    fontWeight: 600,
    color: '#333',
    width: 100,
    whiteSpace: 'nowrap',
  };

  const tdCell = {
    backgroundColor: '#fff',
  };  


  useEffect(() => {
    if(boardQuery === "insert") {
      setBoardTitle(board ? board?.TITLE : "");
      setBoardInptId(userId);
      setBoardInqCnt(0);
      setBoardCntn('');
      setFiles([]);
      setUploadedFiles([]);
      setHrankNotiNo(board?.NOTI_NO || 0);
      setPNotiNo(board?.NOTI_NO || 0);
      setAnswLevl(board?.ANSW_LEVL + 1 || 0);
    }
    else if(boardQuery === "append") {
      const lvl = board?.ANSW_LEVL + 1;
      const indent = " ".repeat(lvl * 3);
      const title = board?.TITLE?.trim() ?? "";   
      setBoardTitle(`${indent}ㄴRe: ${title}`);
      setBoardInptId(userId);
      setBoardInqCnt(0);
      setBoardCntn('');
      setFiles([]);
      setUploadedFiles([]);
      setHrankNotiNo(board?.HRANK_NOTI_NO);
      setPNotiNo(board?.NOTI_NO || 0);
      setAnswLevl(lvl);
    }
    else {
      setBoardTitle(board?.TITLE || '');
      setBoardInptId(board?.INPT_ID || userId);
      setBoardInqCnt(board?.INQ_CNT || 0);
      setBoardCntn(board?.CNTN || '');
    }
  }, [board, userId]);

  return (
    <Paper sx={{ 
          width: 820, 
          height: 400,
          maxHeight: 400,
          display: 'flex',
          flexDirection: 'column', 
          }}>
      {/*}      
      <Typography variant="h6" sx={{ mb: 1 }}>
        <strong>{boardType}</strong>
      </Typography>
      {*/}
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          pl: 1,
          pr: 1,
          minHeight: 0,
        }}
      >
  
        <Table size="small" sx={{ ...tableSx, mb: 1 }}>
          <TableBody>
            <TableRow>
              <TableCell sx={thCell}>작성자</TableCell>
              <TableCell sx={tdCell}>
                {boardQuery === "insert" ? userId : board?.INPT_ID}
              </TableCell>

              <TableCell sx={thCell}>조회수</TableCell>
              <TableCell sx={tdCell}>
                {boardQuery === "insert" ? 0 : board?.INQ_CNT}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={thCell}>제목</TableCell>
              <TableCell style={{ padding: "1px 10px"}} colSpan={3} sx={tdCell}>
                <TextField
                  fullWidth
                  size="small"
                  value={boardTitle || ''}
                  onChange={(e) => setBoardTitle(e.target.value)}
                  placeholder="제목을 입력하세요"
                  sx={{
                    '& input': { height: 24, fontSize: 13, padding: '6px 8px' },
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Table size="small" sx={{ ...tableSx, mb: 1 }}>
          <TableBody>
            <TableRow>
              <TableCell sx={{ ...thCell, verticalAlign: 'top' }}>
                내용
              </TableCell>

              <TableCell colSpan={3} sx={{ p: 0 }}>
                <Box
                  sx={{
                    borderTop: '1px solid #dcdcdc',
                    height: 290,
                  }}
                >
                  <ReactQuill
                    value={boardCntn || ''}
                    onChange={setBoardCntn}
                    style={{ height: 240 }}
                  />
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* 공지사항 첨부파일 영역 임시 미노출
        <Table size="small" sx={tableSx}>
          <TableBody>
            <TableRow>
              <TableCell sx={{ ...thCell, verticalAlign: 'top' }}>
                첨부파일
              </TableCell>

              <TableCell colSpan={3} sx={tdCell}>
                <Box
                  sx={{
                    border: '1px dashed #c0c0c0',
                    borderRadius: 1,
                    p: 1,
                    mb: 1,
                    backgroundColor: '#fafafa',
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <input
                      type="file"
                      multiple
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ fontSize: 12 }}
                    />
                    <Button size="small" variant="outlined"
                      onClick={() => { setFiles([]); setUploadedFiles([]); }}>
                      전체삭제
                    </Button>
                  </Box>
                </Box>

                <List dense disablePadding>
                  {[...uploadedFiles, ...files].map((file, idx) => (
                    <ListItem
                      key={idx}
                      secondaryAction={
                        <IconButton edge="end" onClick={() =>
                          (file.SAVE_FILE_NM || file.saveFileNm)
                            ? handleRemoveUploadedFile(file.SAVE_FILE_NM || file.saveFileNm)
                            : handleRemoveFile(idx - uploadedFiles.length)
                        }>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      }
                      sx={{
                        borderBottom: '1px solid #eee',
                        pl: 1,
                      }}
                    >
                      <ListItemText
                        primary={file.OTXT_FILE_NM || file.otxtFileNm || file.name}
                        secondary={`${((file.FILE_SIZE || file.fileSize || file.size) / 1024).toFixed(1)} KB`}
                        primaryTypographyProps={{ fontSize: 13 }}
                        secondaryTypographyProps={{ fontSize: 11 }}
                      />
                    </ListItem>
                  ))}
                </List>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        */}
      </Box>
    </Paper>
  );
};

export default BoardWritePopup;
